
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'map-pin': {
    width: 18,
    height: 19,
    viewBox: '0 0 18 19',
    data: '<path pid="0" d="M12.96.384a5.04 5.04 0 0 0-5.04 5.04c0 3.315 3.277 4.856 3.687 5.226.42.377.765 1.133.906 1.613.067.232.258.35.447.355a.475.475 0 0 0 .447-.355c.14-.48.486-1.236.906-1.613.41-.37 3.687-1.911 3.687-5.226a5.04 5.04 0 0 0-5.04-5.04zM.783 2.555A.757.757 0 0 0 0 3.312V15.68a1.44 1.44 0 0 0 1.043 1.385l4.461 1.274a.937.937 0 0 0 .512 0l4.427-1.264a1.44 1.44 0 0 1 .744-.013l5.154 1.29a.757.757 0 0 0 .939-.734v-7.411l-1.44 1.149v5.386l-4.32-1.08V13.38l-1.44-2.025v4.325l-3.6 1.03V5.267l.008-.003c.013-.532.09-1.047.225-1.54l-.566.142a1.446 1.446 0 0 1-.746-.013L.965 2.585a.776.776 0 0 0-.182-.03zm12.177 1.43a1.44 1.44 0 1 1 0 2.878 1.44 1.44 0 0 1 0-2.879zm-11.52.234l3.6 1.028v11.462l-3.6-1.028V4.22z"/>'
  }
})
